import React from 'react';

function Page4SubPageB3() {
    return <h1>Browse</h1>;
}

export default Page4SubPageB3;